@if (showBanner) {
  <div class="cookie-banner">
    <div class="cookie-banner-content">
      <div class="cookie-banner-text">
        <h4>{{ 'cookies.banner.title' | translate }}</h4>
        <p>{{ 'cookies.banner.message' | translate }}</p>
      </div>
      <div class="cookie-banner-actions">
        <button
          pButton
          type="button"
          [label]="'cookies.banner.accept' | translate"
          class="p-button-success cookie-btn"
          (click)="acceptCookies()"
          [title]="'cookies.banner.accept' | translate">
        </button>
        <button
          pButton
          type="button"
          [label]="'cookies.banner.decline' | translate"
          class="p-button-outlined cookie-btn"
          (click)="declineCookies()"
          [title]="'cookies.banner.decline' | translate">
        </button>
      </div>
    </div>
  </div>
}